const formatLibraryDate = (dateValue, fallbackLabel) => {
  if (!dateValue) {
    return fallbackLabel;
  }

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) {
    return fallbackLabel;
  }

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export default formatLibraryDate;
